import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { DataAttributeDirective } from '@shared/directives/data-attribute.directive';
import { TranslocoDirective } from '@jsverse/transloco';
import { RouterLink } from '@angular/router';
import { EnvironmentService } from '@services/utils/environment.service';
import { FooterMenu } from '../../interfaces/footer-menu.interface';
import { isFooterMenuItemVisible } from '../../utils/is-footer-menu-item-visible';

@Component({
  selector: 'b2b-footer-menu-column',
  imports: [DataAttributeDirective, TranslocoDirective, RouterLink],
  templateUrl: './footer-menu-column.component.html',
  styleUrl: './footer-menu-column.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterMenuColumnComponent {
  private readonly environmentService = inject(EnvironmentService);

  readonly column = input.required<FooterMenu>();
  readonly index = input.required<number>();
  readonly visibleCategoryItems = computed(() =>
    this.column().categoryItems.filter(menuItem => isFooterMenuItemVisible(menuItem, this.environmentService)),
  );
  readonly visibleColumnFooterLink = computed(() => {
    const columnFooterLink = this.column().columnFooterLink;

    return columnFooterLink && isFooterMenuItemVisible(columnFooterLink, this.environmentService) ? columnFooterLink : null;
  });
}
